/**
 * This should correspond to the Java class au.com.finsyn.acuritywebserver.core.api.navigation.EntityType
 */
export enum EntityType {
	EMPTY = 'EMPTY',
	// CLIENT = 'CLIENT', // unimplemented
	MEMBER = 'MEMBER',
	EMPLOYER = 'EMPLOYER',
	INVESTMENT_MANAGER = 'INVESTMENT_MANAGER',
	ADVISER = 'ADVISER',
}
